"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timestampContractABI = exports.timestampContractSource = void 0;
exports.timestampContractSource = `
  pragma solidity ^0.8.0;

  contract TimestampContract {
    function getTimestamp(uint size) public view returns (uint[] memory) {
      uint[] memory arr = new uint[](size);
      for(uint i = 0; i < size; i++) {
          arr[i] = block.timestamp;
      }
      return arr;
    }
  }
`;
exports.timestampContractABI = {
    contractName: 'Timestamp',
    abi: [
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'size',
                    type: 'uint256',
                },
            ],
            name: 'getTimestamp',
            outputs: [
                {
                    internalType: 'uint256[]',
                    name: '',
                    type: 'uint256[]',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
    ],
    // eslint-disable-next-line max-len
    bytecode: '0x608060405234801561001057600080fd5b5061034b806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c8063b633620c14610030575b600080fd5b61004a6004803603810190610045919061010c565b610060565b60405161005791906101be565b60405180910390f35b606060008267ffffffffffffffff81111561007e5761007d6102ca565b5b6040519080825280602002602001820160405280156100ac5781602001602082028036833780820191505090505b50905060005b838110156100ed57428282815181106100ce576100cd61029b565b5b60200260200101818152505080806100e590610223565b9150506100b2565b5080915050919050565b600081359050610106816102fe565b92915050565b600060208284031215610122576101216102f9565b5b6000610130848285016100f7565b91505092915050565b600061014583836101af565b60208301905092915050565b600061015c826101f0565b6101668185610208565b9350610171836101e0565b8060005b838110156101a25781516101898882610139565b9750610194836101fb565b925050600181019050610175565b5085935050505092915050565b6101b881610219565b82525050565b600060208201905081810360008301526101d88184610151565b905092915050565b6000819050602082019050919050565b600081519050919050565b6000602082019050919050565b600082825260208201905092915050565b6000819050919050565b600061022e82610219565b91507fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff8214156102615761026061026c565b5b600182019050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b600080fd5b61030781610219565b811461031257600080fd5b5056fea2646970667358221220a8438750f25cb95b0eca4973a782785022405d01f1d36afbfd63f56086a8418c64736f6c63430008070033',
};
//# sourceMappingURL=timestamp.js.map